import React from 'react';
import FadeIn from 'react-lazyload-fadein';
import { Parallax } from 'react-scroll-parallax';

const CaseStudyItem = (props) => (
    <section className="case-studies__item">
        <div className="case-studies__images">
            <Parallax
                disabled={props.isDisabled}
                className="desktop-frame"
                offsetYMax={40}
                offsetYMin={-40}
            >
                    <div className="desktop-frame__top">
                        <div className="desktop-frame__circle"></div>
                    </div>
                    <div className="desktop-frame__inner">
                        <FadeIn height={0}>
                            {onload => (
                                <img
                                    src={props.desktopImage.fields.file.url}
                                    alt={props.desktopImage.fields.description}
                                    onLoad={onload}
                                />
                            )}
                        </FadeIn>
                    </div>
            </Parallax>
            <Parallax
                disabled={props.isDisabled}
                className="mobile-frame"
                offsetYMax={80}
                offsetYMin={-80}
            >
                <div className="mobile-frame__inner-wrapper">
                    <div className="mobile-frame__inner">
                        <FadeIn height={0}>
                            {onload => (
                                <img
                                    src={props.mobileImage.fields.file.url}
                                    alt={props.mobileImage.fields.description}
                                    onLoad={onload}
                                />
                            )}
                        </FadeIn>
                    </div>
                    <div className="mobile-frame__circle"></div>
                </div>
            </Parallax>
        </div>
        <Parallax
            disabled={props.isDisabled}
            className="case-studies__text"
            offsetYMax={80}
            offsetYMin={-80}
        >
            <h1><a href={props.siteUrl} target="_blank" rel="noopener noreferrer">{props.title}</a></h1>
            <h2>{props.subHeading}</h2>
            <p>{props.description}</p>
        </Parallax>
    </section>
)

export default CaseStudyItem;


// WEBPACK FOOTER //
// ./src/CaseStudies/CaseStudyItem.js